var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "message-widget", attrs: { id: "form" } },
    [
      _c("div", { staticClass: "message-widget__title-wrap" }, [
        _c("span", { staticClass: "icon-message message-widget__title-icon" }),
        _vm._v(" "),
        _c("h2", { staticClass: "message-widget__title" }, [
          _vm._v(
            _vm._s(
              _vm.locales &&
                _vm.locales.property &&
                _vm.locales.property.message
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("theme-textarea", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "`required`"
          }
        ],
        attrs: {
          label: "",
          name: "message",
          placeholder:
            _vm.locales &&
            _vm.locales.property &&
            _vm.locales.property.message_placeholder,
          gray: true
        },
        model: {
          value: _vm.body,
          callback: function($$v) {
            _vm.body = $$v
          },
          expression: "body"
        }
      }),
      _vm._v(" "),
      _vm.isGuest
        ? _c(
            "a",
            {
              class: [
                "theme-btn theme-btn--white",
                { "theme-btn--white-disabled": !_vm.body }
              ],
              attrs: { "data-feature": "open-modal", "data-target": "login" }
            },
            [_vm._v("\n        " + _vm._s(_vm.buttonName) + "\n    ")]
          )
        : _c(
            "button",
            {
              class: [
                "theme-btn theme-btn--white",
                { "theme-btn--white-disabled": !_vm.body }
              ],
              attrs: { disabled: _vm.isDisabled },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.send.apply(null, arguments)
                }
              }
            },
            [_vm._v(_vm._s(_vm.buttonName) + "\n    ")]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92cf1960", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92cf1960","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MessageWidget.vue
// module id = 706
// module chunks = 1